import { gql } from "@apollo/client";

export const GET_BLACKLISTED_USERS = gql(`
  query GetBlacklistedUsers {
    getBlacklistedUsers {
      id
      storeId
      userId
      createdAt
      updatedAt
      store {
        id
        title
      }
      user {
        id
        name
        phone
        email
      }
    }
  }
`);

export const BLOCK_USER = gql(`
  mutation BlockUser($userId: Int!) {
    blockUser(userId: $userId) {
      ok
      error
      blacklist {
        id
        storeId
        userId
        createdAt
        user {
          id
          name
          phone
        }
      }
    }
  }
`);

export const UNBLOCK_USER = gql(`
  mutation UnblockUser($userId: Int!) {
    unblockUser(userId: $userId) {
      ok
      error
    }
  }
`);
